module.exports = __webpack_public_path__ + "static/media/Tempted.f936fbe3.jpg";